<template>
  <frontoffice-frame class="public-edit">
    <offline-booking-form-edit :anonymous="anonymous" />
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import OfflineBookingFormEdit from '@/components/frontoffice/OfflineBooking/OfflineBookingFormEdit'
import CommonApi from "@/api/commonApi";

export default {
  components: {
    frontofficeFrame,
    OfflineBookingFormEdit
  },

  data () {
    return {
      anonymous: true
    }
  }
}
</script>

<style scoped>
.public-edit {
  padding-top: 2%;
}
</style>
